import { Card, CardContent } from "@/components/ui/card";
import LoginForm from "@/modules/auth/login-form";

const SignInPage = () => {
  return (
    <div className="flex h-screen w-full flex-col bg-white">
      <main className="flex flex-1 items-center justify-center">
        <Card className="mx-auto w-full max-w-md border-0 bg-white shadow-none">
          <CardContent className="px-0 pt-6">
            <div className="mb-8 text-center">
              <h1 className="mb-2 text-2xl font-bold text-gray-700">
                Log in to <span className="text-primary">Stakeholder Map</span>
              </h1>
              <p className="text-gray-600">
                Welcome back! We are pleased to see you again.
              </p>
            </div>

            <LoginForm />
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default SignInPage;
